<template>
  <div class="workflow" v-if="$can('workflow_nodes_view')">
    <v-snackbar v-model="snackbar" :timeout="4000" top :color="color">
      <span>{{ message }}</span>
    </v-snackbar>
    <v-container>
      <v-layout column>
        <v-flex xs12>
          <h1>{{ $t('workflowNodesMsg') }}</h1>
          <v-breadcrumbs>
            <v-breadcrumbs-item disabled v-if="dashBreadcrumb">
              {{ $t('dashboardMsg') }}
            </v-breadcrumbs-item>
            <v-breadcrumbs-item
              v-if="!dashBreadcrumb"
              @click="changeView('default')"
            >
              <a>{{ $t('dashboardMsg') }}</a></v-breadcrumbs-item
            >
            <v-breadcrumbs-divider >/</v-breadcrumbs-divider>
            
            <v-breadcrumbs-item @click="$router.push('workflow')"><a>{{ $t('workflowMsg') }}</a></v-breadcrumbs-item>
            <v-breadcrumbs-divider >/</v-breadcrumbs-divider>
            <v-breadcrumbs-item disabled >{{ $t('nodesMsg') }}</v-breadcrumbs-item>
            
            <v-breadcrumbs-divider >/</v-breadcrumbs-divider>
            
            <v-breadcrumbs-item disabled v-if="showBreadcrumb">
              {{ $t('viewWorkflowNodesMsg') }}</v-breadcrumbs-item
            >
          </v-breadcrumbs>
        </v-flex>
        <div v-if="view == 'default'">
          <v-flex xs12 class="mt-5 mb-2">
            <div class="mx-5">
              <v-layout row wrap>
                <v-flex xs12 md4 class="hidden-sm-and-down"> </v-flex>

                <v-flex xs12 md4>
                  <div class="pa-1">
                    <v-text-field
                      class="text_field header"
                      outlined
                      dense
                      label="Search"
                      v-on:keyup.enter="search"
                      v-model="searchTerm"
                      @input="enableSearch()"
                    ></v-text-field>
                  </div>
                </v-flex>
                <v-flex xs12 md2>
                  <div class="pa-1">
                    <v-btn
                      class="secondary text-none"
                      depressed
                      block
                      @click="search"
                      :loading="searchLoader"
                      :disabled="searchButtonDisabled"
                    >
                      {{ $t('searchMsg') }}
                      <v-icon right>mdi-magnify</v-icon>
                    </v-btn>
                  </div>
                </v-flex>
                <v-flex xs12 md2 class="hidden-sm-and-down"> </v-flex>
              </v-layout>
            </div>
          </v-flex>
          
          <v-divider class="mt-5 mx-5"></v-divider>
          <v-flex xs12 class="mt-5">
            <div align="right">
              <v-btn
                depressed
                class="primary text-none"
                @click="addNode()"
                v-if="$can('workflow_nodes_create')"
              >
                {{$t('addWorkflowNodeMsg')}}
                <v-icon right> mdi-plus-circle-outline </v-icon>
              </v-btn>
            </div>
          </v-flex>
          <v-flex xs12 class="mt-5">
            <div v-if="workflownodes.length == 0">
              <v-card elevation="0">
                <v-layout row wrap>
                  <v-flex xs12 md1>
                    <v-container fill-height fluid>
                      <v-row align="center" justify="center">
                        <v-col class="text-center">
                          <v-icon large class="primary--text">
                            mdi-alert-circle-outline
                          </v-icon>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-flex>
                  <v-flex xs12 md11>
                    <v-container fill-height fluid>
                      <v-row align="center" justify="center">
                        <v-col class="text-center"> {{ $t('noWorkflowNodeFoundMsg') }} </v-col>
                      </v-row>
                    </v-container>
                  </v-flex>
                </v-layout>
              </v-card>
            </div>
            <div v-else>
              <v-progress-linear
                v-if="workflownodesLoader"
                height="1"
                indeterminate
                color="primary"
              ></v-progress-linear>
              <div class="hidden-sm-and-down">
                <v-card elevation="0" class="pa-2">
                  <v-simple-table>
                    <template v-slot:default>
                      <thead>
                        <tr class="secondary white--text">
                         
                          <th class="text-left white--text">{{ $t('workflowNameMsg') }}</th>
                          <th class="text-left white--text">{{ $t('nodeTypeMsg') }}</th>
                          <th class="text-left white--text">{{ $t('nodeNameMsg') }}</th>
                          <th class="text-left white--text">{{ $t('assigneeTypeMsg')}}</th>
                          <th class="text-left white--text">{{ $t('assigneeMsg') }} </th>
                          <th class="text-left white--text">{{ $t('isFirstApproverMsg') }}</th>
                          <th class="text-right white--text">{{ $t('actionsMsg') }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr  v-for="item in filterNodes(workflownodes)" :key="item.id">
                          <td>{{ item.workflow.workflow_name }}</td>
                          <td>{{ item.node_type }}</td>
                          <td>{{ item.node_name }}</td>
                          <td v-if="item.assignee_type == 1">{{ $t('userMessage') }}</td>
                          <td v-if="item.assignee_type == 2">{{ $t('roleMessage') }}</td>
                          <td v-if="item.assignee_type == null">{{ $t('notApplicableMsg') }}</td>
                          <td v-if="item.assignee_type == 1">{{ formData.user.find(e => e.id === item.assignee_id).name }}</td>
                          <td v-if="item.assignee_type == 2">{{ formData.role.find(e => e.id === item.assignee_id).name }}</td>
                          <td v-if="item.assignee_type == null">{{ $t('notApplicableMsg') }}</td>
                          <td v-if="item.is_start_node == 1">{{ $t('yesMsg') }}</td>
                          <td v-else-if="item.is_start_node == 0">{{ $t('noMsg') }}</td>
                          <td>
                            <div align="right">
                              <v-tooltip top v-if="$can('workflow_nodes_view')">
                                  <template v-slot:activator="{ on, attrs }">
                                      <v-btn icon @click="gotoSteps(item.id)" class="button mr-1 warning--text" v-bind="attrs" v-on="on">
                                          <v-icon small>
                                              mdi-file-tree
                                          </v-icon>
                                      </v-btn>
                                  </template>
                                  <span>{{ $t('stepsMsg') }}</span>
                              </v-tooltip>
                              <v-tooltip top v-if="$can('workflow_nodes_view')">
                                  <template v-slot:activator="{ on, attrs }">
                                      <v-btn icon @click="showworkflow(item)" class="button mr-1 primary--text" v-bind="attrs" v-on="on">
                                          <v-icon small>
                                              mdi-eye
                                          </v-icon>
                                      </v-btn>
                                  </template>
                                  <span>{{ $t('viewMsg') }}</span>
                              </v-tooltip>
                              <v-tooltip top v-if="$can('workflow_nodes_edit')">
                                  <template v-slot:activator="{ on, attrs }">
                                      <v-btn icon @click="editworkflow(item)" class="button mr-1 success--text" v-bind="attrs" v-on="on">
                                          <v-icon small>
                                              mdi-pencil
                                          </v-icon>
                                      </v-btn>
                                  </template>
                                  <span>{{ $t('editMsg') }}</span>
                              </v-tooltip>
                              <v-tooltip top v-if="$can('workflow_nodes_archive')">
                                  <template v-slot:activator="{ on, attrs }">
                                      <v-btn icon @click="deleteworkflow(item)" :loading="loading && workflownodeIndex == item.id" class="button error--text" v-bind="attrs" v-on="on">
                                          <v-icon small>
                                              mdi-delete
                                          </v-icon>
                                      </v-btn>
                                  </template>
                                  <span>{{ $t('deleteMsg') }}</span>
                              </v-tooltip>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-card>
              </div>
              <div class="hidden-md-and-up">
                <v-layout column>
                  <template v-for="(workflow, index) in workflownodes">
                    <div :key="index">
                      <v-flex xs12 class="mb-2">
                        <v-card elevation="0">
                          <div class="pa-5">
                            <v-layout column>
                              <v-flex xs12>
                                <v-layout row wrap>
                                  <v-flex xs11>
                                    <div class="title primary--text">
                                      <b>{{ workflow.node_name }}</b>
                                    </div>
                                  </v-flex>
                                  <v-flex xs1>
                                    <v-btn
                                      depressed
                                      class="red--text"
                                      :loading="
                                        loading && workflownodeIndex == workflow.id
                                      "
                                      icon
                                      @click="deleteworkflow(workflow)"
                                      v-if="$can('workflow_nodes_archive')"
                                    >
                                      <v-icon> mdi-delete </v-icon>
                                    </v-btn>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                              <v-divider class="mt-2"></v-divider>
                              <v-flex xs12 class="mt-1">
                                <v-layout column>
                                  <v-flex xs12 class="mt-1">
                                    <div><b>{{ $t('nodeNameMsg') }}</b></div>
                                    <div>{{ workflow.node_name }}</div>
                                  </v-flex>
                                  <v-flex xs12 class="mt-1"> </v-flex>
                                  <v-flex xs12 class="mt-5">
                                    <v-layout row wrap>
                                      <v-flex xs12>
                                        <div class="pa-1">
                                          <v-btn
                                            depressed
                                            class="
                                              primary
                                              text-none
                                              white--text
                                            "
                                            block
                                            @click="showworkflow(workflow)"
                                            v-if="$can('workflow_nodes_view')"
                                            >{{ $t('viewMsg') }}
                                            <v-icon right> mdi-eye </v-icon>
                                          </v-btn>
                                        </div>
                                      </v-flex>
                                      <v-flex xs12>
                                        <div class="pa-1">
                                          <v-btn
                                            depressed
                                            class="
                                              green
                                              darken-1
                                              text-none
                                              white--text
                                            "
                                            block
                                            @click="editworkflow(workflow)"
                                            v-if="$can('workflow_nodes_edit')"
                                            >{{ $t('editMsg') }}
                                            <v-icon right>
                                              mdi-border-color
                                            </v-icon>
                                          </v-btn>
                                        </div>
                                      </v-flex>
                                    </v-layout>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                            </v-layout>
                          </div>
                        </v-card>
                      </v-flex>
                    </div>
                  </template>
                </v-layout>
              </div>
            </div>
          </v-flex>
          <v-flex xs12 class="mt-5">
            <v-layout row wrap>
              <v-flex xs12 md3>
                <div v-if="length != 0">
                  <b class="primary--text ml-4">{{ $t('totalMsg') }} </b
                  >{{ filterNodes(workflownodes).length | formatNumber }}
                </div>
              </v-flex>
              <v-flex xs12 md9>
                <div align="right">
                  <v-pagination
                    v-if="length != 0 && length != 1"
                    :length="length"
                    total-visible="10"
                    v-model="workflownodesPagination.current_page"
                    @input="changePage()"
                    circle
                  >
                  </v-pagination>
                </div>
              </v-flex>
            </v-layout>
          </v-flex>
        </div>
        <div v-if="view == 'create'">
          <v-flex class="mt-5">
            <v-card elevation="0">
              <v-card-title class="primary white--text">
                <v-spacer></v-spacer>
                <div v-if="workflow_node.id == null">{{ $t('addWorkflowNodeMsg') }}</div>
                <div v-else>{{ $t('editWorkflowNodeMsg') }}</div>
                <v-spacer></v-spacer>
                <v-btn icon @click="changeView('default')">
                  <v-icon class="white--text"> mdi-close </v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text>
                <v-form v-model="valid" ref="form" lazy-validation>
                  <v-layout row wrap class="mt-5">
                 
                    <v-flex xs12 md6>
                      <div class="pa-3">
                        <div>{{ $t('workflowNameMsg') }}*</div>
                        <v-select
                          :items="formData.workflow"
                          v-model="$store.state.currentWorkFlow"
                          readonly
                          class="text_field background"
                          item-value="id"
                          item-text="workflow_name"
                          outlined
                          dense
                          :rules="inputRules"
                        ></v-select>
                      </div>
                    </v-flex>
                    <v-flex xs12 md6>
                      <div class="pa-3">
                        <div>{{ $t('nodeNameMsg') }}*</div>
                        <v-text-field
                          class="text_field background"
                          outlined
                          dense
                          v-model="workflow_node.node_name"
                          :rules="inputRules_SpecChar"
                        ></v-text-field>
                      </div>
                    </v-flex>

                    <v-flex xs12 md6 v-if="workflow_node.node_type == 'Action'">
                      <div class="pa-3">
                        <div>{{ $t('assigneeTypeMsg') }}*</div>
                        <v-select
                          :items="assigneeType"
                          v-model="workflow_node.assignee_type"
                          class="text_field background"
                          item-value="id"
                          item-text="name"
                          outlined
                          dense
                          :rules="inputRules"
                        ></v-select>
                      </div>
                    </v-flex>

                    <v-flex xs12 md6 v-if="workflow_node.node_type == 'Action' && workflow_node.assignee_type == 1">
                      <div class="pa-3">
                        <div>{{ $t('assigneeIdMsg') }}*</div>
                        <v-select
                          :items="formData.user"
                          v-model="workflow_node.assignee_id"
                          class="text_field background"
                          item-value="id"
                          item-text="name"
                          outlined
                          dense
                          :rules="inputRules"
                        ></v-select>
                      </div>
                    </v-flex>

                    <v-flex xs12 md6 v-if="workflow_node.node_type == 'Action' && workflow_node.assignee_type == 2">
                      <div class="pa-3">
                        <div>{{ $t('assigneeIdMsg') }}*</div>
                        <v-select
                          :items="formData.role"
                          v-model="workflow_node.assignee_id"
                          class="text_field background"
                          item-value="id"
                          item-text="name"
                          outlined
                          dense
                          :rules="inputRules"
                        ></v-select>
                      </div>
                    </v-flex>

                    <v-flex xs12 md6 v-if="workflow_node.node_type == 'Action'">
                      <div class="pa-3">
                        <div>{{ $t('isFirstApproverMsg') }} *</div>
                        <v-select
                          :items="isStartNode"
                          v-model="workflow_node.is_start_node"
                          class="text_field background"
                          item-value="id"
                          item-text="name"
                          outlined
                          dense
                          :rules="inputRules"
                        ></v-select>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  depressed
                  class="secondary text-none mt-3"
                  @click="save"
                  :disabled="!valid"
                  :loading="loading"
                >
                  {{ $t('saveMsg') }}
                  <v-icon right> mdi-content-save </v-icon>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </div>
        <div v-if="view == 'show'">
          <v-card elevation="0" class="pa-3">
            <div><b>{{ $t('workflowNameMsg') }}: </b>{{ assignedworkflow.node_name }}</div>
            <div><b>{{ $t('nodeNameMsg') }}: </b>{{ assignedworkflow.workflow.workflow_name }}</div>
            <div><b>{{ $t('nodeTypeMsg') }}: </b>{{ assignedworkflow.node_type }}</div>
            <div v-if="assignedworkflow.assignee_type == 1"><b>{{ $t('assigneeTypeMsg') }}: </b>{{ $t('userMessage') }}</div>
            <div v-if="assignedworkflow.assignee_type == 2"><b>{{ $t('assigneeTypeMsg') }}: </b>{{ $t('roleMessage') }}</div>
            <div v-if="assignedworkflow.assignee_type == 1"><b>{{ $t('assigneeMsg') }}: </b>{{ formData.user.find(e => e.id === assignedworkflow.assignee_id).name }}</div>
            <div v-if="assignedworkflow.assignee_type == 2"><b>{{ $t('assigneeMsg') }}: </b>{{ formData.role.find(e => e.id === assignedworkflow.assignee_id).name }}</div>
            <div v-if="assignedworkflow.is_start_node == 1"><b>{{ $t('isFirstApproverMsg') }} </b>{{ $t('yesMsg') }}</div>
            <div v-if="assignedworkflow.is_start_node == 0"><b>{{ $t('isFirstApproverMsg') }} </b>{{ $t('noMsg') }}</div>
            <!-- <div v-if="assignedworkflow.has_attachment == 1"><b>Has Attachment?: </b>{{ $t('yesMsg') }}</div>
            <div v-if="assignedworkflow.has_attachment != 1"><b>Has Attachment?: </b>{{ $t('noMsg') }}</div>             -->
          </v-card>
        </div>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import apiCall from "@/utils/api";
import { mapGetters, mapActions } from "vuex";
import Vue from "vue";
var numeral = require("numeral");
Vue.filter("formatNumber", function (value) {
    return numeral(value).format("0,0");
});
Vue.filter("formatMoney", function (value) {
    return numeral(value).format("0,0.00");
});

export default {
  components: {},
  data() {
    return {
      dashBreadcrumb: true,
      showBreadcrumb: false,

      view: "default",
      page: 1,
      loading: false,
      valid: true,
      message: "",
      color: "",
      delete: false,
      workflownodeIndex: null,
      printIndex: null,
      snackbar: false,
      inputRules: [
        v => !!v || this.$t('inputIsRequiredMessage'),
      ],
      inputRules_SpecChar: [
        v => !!v || this.$t('inputIsRequiredMessage'),
        v => !/[!@#$%^&*()+\=\[\]{};:"\\|,<>\/?]+/.test(v) || this.$t('mustNotHaveASpecialCharacterMsg')
      ],
      searchTerm: null,
      searchLoader: false,
      searchButtonDisabled: false,
      formData:null,
      filteredworkflownodes: false,
      searchButtonDisabled: false,
      assigneeType:[
        { id:"1" , name: this.$t('userMessage') },
        { id:"2" , name: this.$t('roleMessage') },
      ],
      isStartNode: [
        { id: 1, name: this.$t('yesMsg') },
        { id: 2, name: this.$t('noMsg') },
      ],
      // firstApproverTypes: [
      //   { id: "D", name: "Default" },
      //   { id: "C", name: "Conditional" },
      // ],
      // nodeTypes: [
      //   { id: "Action", name: "Action" },
      //   { id: "Billing", name: "Billing" },
      // ],
      hasAttachment: [
        { id: 1, name: this.$t('yesMsg') },
        { id: 2, name: this.$t('noMsg') },
      ],
      workflow_node: {
        id: null,
        workflow_id: null,
        node_name: null,
        assignee_type:null,
        assignee_id:null,
        is_start_node:null,
        first_approver_type: "D",
        node_type: { id: "Action", name: "Action" },
        billableItems: [],
        has_attachment: 2,
      },

      assignedworkflow: {
        workflow_id: null,
        node_name: null,
        assignee_type:null,
        assignee_id:null,
        is_start_node:null,
        first_approver_type: null,
        node_type: null, 
        billableItems: null,
        has_attachment: 2,
      },
      workflow_node_options: {
        bill_option: null,
      },
      billOptionDetailsArray: [],
    };
  },
  created() {
    if(this.$can('workflow_nodes_view')){
      this.fetchworkflownodes(this.workflownodesPagination.current_page);
      this.getFormData();
    }
  },
  methods: {
    ...mapActions([
      "fetchworkflownodes",
      "startworkflownodesLoader",
      "stopworkflownodesLoader",
      "filterworkflownodes",
    ]),
    enableSearch() {
      this.searchButtonDisabled = false;
    },
    gotoSteps(step){
      this.$store.state.currentNode = step;
      this.$router.push('workflowsteps');
    },
    filterNodes(workflow_nodes){
      const id = this.$store.state.currentWorkFlow;
      return  workflow_nodes.filter((a)=>{if(a.workflow_id == id){return a;}});
    },
    addNode(){
      this.resetFields();
      this.changeView('create');
    },
    showworkflow(workflow) {
      this.assignedworkflow.workflow_id = workflow.workflow_id;
      this.assignedworkflow.node_name = workflow.node_name;
      this.assignedworkflow.assignee_type = workflow.assignee_type;
      this.assignedworkflow.assignee_id = workflow.assignee_id;
      this.assignedworkflow.is_start_node = workflow.is_start_node;
      this.assignedworkflow.node_type = workflow.node_type;
      this.assignedworkflow = workflow;

      if(workflow.wfnodesbilldetails.length > 0){
        for (var i = 0; i < workflow.wfnodesbilldetails.length; i++) {
          if(this.assignedworkflow.billableItems == null){
            this.assignedworkflow.billableItems = workflow.wfnodesbilldetails[i].wfnodesbilloption.bill_option;
          }else{
            this.assignedworkflow.billableItems = this.assignedworkflow.billableItems + ', ' + workflow.wfnodesbilldetails[i].wfnodesbilloption.bill_option;
          }
        }
      }

      this.changeView("show");
    },
    editworkflow(workflow) {
      this.billOptionDetailsArray = [];
      
      this.workflow_node.id = workflow.id;   
      this.workflow_node.workflow_id = workflow.workflow_id;
      this.workflow_node.node_name = workflow.node_name;
      this.workflow_node.assignee_type = workflow.assignee_type;
      if(workflow.is_start_node == 1){
        this.workflow_node.is_start_node = workflow.is_start_node;  
      }else{
        this.workflow_node.is_start_node = 2;
      }      
      this.workflow_node.assignee_id = workflow.assignee_id;
      this.workflow_node.node_type = workflow.node_type;

      if(workflow.wfnodesbilldetails.length > 0){
        for (var i = 0; i < workflow.wfnodesbilldetails.length; i++) {
          let billOptionDetailsArrayCopy = this.billOptionDetailsArray;
          billOptionDetailsArrayCopy.push(Object.assign({}, workflow.wfnodesbilldetails[i].wfnodesbilloption));
        }
      }
      if(workflow.has_attachment == 1){
        this.workflow_node.has_attachment = workflow.has_attachment;  
      }else{
        this.workflow_node.has_attachment = 2;
      }      

      this.changeView("create");
    },

    getFormData() {
      apiCall({
        url: "/api/workflownode?type=formData",
        method: "GET",
      })
        .then((resp) => {
          this.formData = resp;
        })
        .catch((error) => {
          this.message = this.$t("anErrorOccurredMsg");
          this.color = "error";
        });
    },

    save() {
        this.workflow_node.workflow_id = this.$store.state.currentWorkFlow;
        this.workflow_node.billableItems = this.billOptionDetailsArray;
        if (this.$refs.form.validate()) {
          this.loading = true;

          if(this.workflow_node.node_type == 'Billing' && this.billOptionDetailsArray.length < 1){ 
            this.message = this.$t('workflowBillingNodeError');
            this.color = "error";
            this.loading = false;
            this.snackbar = true;
          }
          else if (this.workflow_node.id != null) {
            apiCall({
              url: "/api/workflownode/" + this.workflow_node.id,
              data: this.workflow_node,
              method: "PUT",
            })
              .then((resp) => {
                this.message = this.$t('workflowNodeUpdatedSuccessMsg');
                this.color = "orange";
                this.loading = false;
                this.snackbar = true;
                this.changeView("default");
                this.fetchworkflownodes(1);
                this.resetFields();
              })
              .catch((error) => {
                this.message = this.$t('anErrorOccurredMsg');
                this.color = "error";
                this.loading = false;
                this.snackbar = true;
                this.resetFields();
              });
          } else {
            apiCall({
              url: "/api/workflownode",
              data: this.workflow_node,
              method: "POST",
            })
              .then((resp) => {
                this.message = this.$t('workflowNodeAddedSuccessMsg');
                this.color = "success";
                this.loading = false;
                this.snackbar = true;
                this.changeView("default");
                this.fetchworkflownodes(1);
                this.resetFields();
              })
              .catch((error) => {
                console.log(error);
                this.message = this.$t('anErrorOccurredMsg');
                this.color = "error";
                this.loading = false;
                this.snackbar = true;
                this.resetFields();
              });
          }
        }      
    },


    search() {
      if (this.searchTerm == null) {
        this.searchButtonDisabled = true;
      } else {
        this.searchLoader = true;
        this.searchButtonDisabled = false;
        this.startworkflownodesLoader();
        apiCall({
          url: "/api/workflownode?type=search&search=" + this.searchTerm,
          method: "GET",
        })
          .then((resp) => {
            this.filterworkflownodes(resp);
            this.searchLoader = false;
            this.stopworkflownodesLoader();
            this.filteredworkflownodes = true;
          })
          .catch((error) => {
            console.log(error.response);
            this.searchLoader = false;
            this.stopworkflownodesLoader();
            this.message = this.$t("anErrorOccurredMsg");
            this.color = "error";
            this.snackbar = true;
          });
      }
    },
    changeView(view) {
      if (view == "default") {
        this.workflow_node.id = null;
        this.workflow_node.workflow_name = null;
        this.workflow_node.workflow_mapping_id = null;
        this.dashBreadcrumb = true;
        this.showBreadcrumb = false;
      } else if (view == "create") {
        this.workflow_node.node_type = 'Action';        
      } else if (view == "show") {
        this.dashBreadcrumb = false;
        this.showBreadcrumb = true;
      }
      this.view = view;
    },
    changePage() {
      if (this.filteredworkflownodes == true) {
        this.searchButtonDisabled = false;
        this.startworkflownodesLoader();
        apiCall({
          url:
            "/api/workflownode?page=" +
            this.workflownodesPagination.current_page +
            "&type=search&search=" +
            this.searchTerm,
          method: "GET",
        })
          .then((resp) => {
            this.filterworkflownodes(resp);
            this.stopworkflownodesLoader();
          })
          .catch((error) => {
            console.log(error.response);
            this.stopworkflownodesLoader();
            this.message = this.$t("anErrorOccurredMsg");
            this.color = "error";
            this.snackbar = true;
          });
      } else {
        this.fetchworkflownodes(this.workflownodesPagination.current_page);
      }
    },
    deleteworkflow(item) {
      confirm(this.$t('workflowNodeDeleteWarningMsg')) &&
        (this.delete = true);
      if (this.delete) {
        this.loading = true;
        this.workflownodeIndex = item.id;
        apiCall({ url: "/api/workflownode/" + item.id, method: "DELETE" })
          .then((resp) => {
            this.message = this.$t('workflowNodeDeleteSuccessMsg');
            this.color = "success";
            this.snackbar = true;
            this.loading = false;
            this.delete = false;
            this.workflownodeIndex = null;
            this.fetchworkflownodes(this.workflownodesPagination.current_page);
          })
          .catch((error) => {
            this.message = this.$t('anErrorOccurredMsg');
            this.color = "error";
            this.snackbar = true;
            this.loading = false;
            this.delete = false;
            this.workflownodeIndex = null;
            console.log(error.response);
          });
      }
    },
    resetFields(){
      this.workflow_node.id= null;
      this.workflow_node.workflow_id= null;
      this.workflow_node.node_name= null;
      this.workflow_node.assignee_type= null;
      this.workflow_node.is_start_node= null;      
      this.workflow_node.assignee_id = null;
      this.workflow_node.node_type= null;
      this.billOptionDetailsArray = [];
    },
  },
  computed: {
    ...mapGetters([
      "workflownodes",
      "workflownodesPagination",
      "workflownodesLoader",
    ]),
    currentWorkFlow(){
      return this.$store.state.currentWorkFlow;
    },
    length: function () {
      return Math.ceil(
        this.workflownodesPagination.total / this.workflownodesPagination.per_page
      );
    },
  },
};
</script>